module.exports = __webpack_public_path__ + "static/media/university-atsi-2.234cc54f.jpg";